import { useTranslation } from 'react-i18next'
import { useRef, memo } from 'react'
import Flag from 'react-world-flags'

const LANGUAGES = [
  { code: 'en', label: 'English', countryCode: 'US' },
  { code: 'fr', label: 'Français', countryCode: 'FR' },
  { code: 'th', label: 'ไทย', countryCode: 'TH' },
] as const

function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const triggerRef = useRef<HTMLDivElement>(null)

  const currentLanguage = LANGUAGES.find(lang => lang.code === i18n.language) || LANGUAGES[0]

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode)
    const elem = document.activeElement as HTMLElement
    elem?.blur()
  }

  return (
    <div className="dropdown dropdown-end">
      <div ref={triggerRef} tabIndex={0} role="button" className="btn btn-ghost btn-circle" title={t('common.language')}>
        <Flag code={currentLanguage.countryCode} className="w-7 h-5 rounded" />
      </div>
      <ul tabIndex={-1} className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-40 p-2 shadow">
        {LANGUAGES.map((lang) => (
          <li key={lang.code}>
            <a
              onClick={() => handleLanguageChange(lang.code)}
              className={i18n.language === lang.code ? 'active' : ''}
            >
              <Flag code={lang.countryCode} className="w-6 h-4 rounded" />
              <span className="flex-1">{lang.label}</span>
              {i18n.language === lang.code && (
                <span className="text-success">✓</span>
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default memo(LanguageSwitcher)
